import { useEffect } from "react";

export const usePaginationTextReplace = () => {
  useEffect(() => {
    const replacePaginationText = () => {
      const paginationButtons = document.querySelectorAll(
        ".TablePaginationAction"
      );

      paginationButtons.forEach((button) => {
        const spans = button.querySelectorAll("span");
        spans.forEach((span) => {
          if (span.textContent === "Previous") {
            span.textContent = "Предыдущая";
          } else if (span.textContent === "Next") {
            span.textContent = "Следующая";
          }
        });
      });
    };
    replacePaginationText();

    const observer = new MutationObserver(() => {
      replacePaginationText();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, []);
};
